module.exports = __webpack_public_path__ + "static/media/application-standard.707bc9de.png";